<section class="pt-4" style="min-height: 390px">
  <div id="home-depot-desktop-section" class="mx-md-auto position-relative"
       style="max-width: 1220px">
    <div class="mobile-section-1-1 d-flex flex-column flex-md-row position-relative justify-content-around">
      <img style="top: 20px; right: 20px" class="mb-md-5 position-absolute" width="70" src="assets/market-walmart/cubatel_logo.svg"
           alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
      <picture class="d-flex d-md-none">
        <source data-srcset="assets/market-home-depot/home_depot_boxes.png" type="image/webp">
        <source data-srcset="assets/market-home-depot/home_depot_boxes.png" type="image/png">
        <img width="324" height="282" class="lazyload m-auto" alt="Home Depot para Cuba"
             data-src="assets/market-home-depot/home_depot_boxes.png">
      </picture>
      <div class="mobile-section-1-1-container amazon-texts d-flex flex-column align-items-start pt-0 pt-md-4 pb-4 py-md-4 px-3 mt-md-4"
           style="top:5%;left:5%">
        <h2 class="Poppins text-center text-md-left"><span class="font-weight-normal amazon-text-1 text-white">
          <span class="font-weight-normal">Todos los productos de</span><br>
            <span class="font-weight-bold d-block d-md-none">The Home Depot <span class="font-weight-normal">en</span> Cubatel</span>
            <span class="font-weight-bold d-none d-md-block">The Home Depot en Cubatel</span>
        </span></h2>
        <span class="h2 font-weight-normal  Poppins text-center text-md-left text-uppercase mt-2 mb-3 align-self-center align-self-md-start" style="text-transform: unset; font-size: 24px; line-height: 26px; color: #1A1A1A"><span>Compra aquí y los entregamos<br>
en tu casa en Cuba</span></span>
        <a routerLink="/market/envios/home-depot-para-cuba"
           class="text-white btn mb-3 my-md-3 px-5 py-2 font-weight-bold OpenSans rounded-pill align-items-center justify-content-center mx-auto ml-md-0 mr-md-auto w-75"
           style="background: #FE592C; font-size: 20px;max-width: 250px">
          Comprar Ahora</a>
      </div>
      <div class="mobile-section-1-1-img flex-column flex-md-row position-relative d-flex align-items-end mb-4 mb-md-0">

        <picture class="d-none d-md-flex">
          <source data-srcset="assets/market-home-depot/home_depot_boxes.png" type="image/webp">
          <source data-srcset="assets/market-home-depot/home_depot_boxes.png" type="image/png">
          <img width="400" height="349" class="lazyload m-auto" alt="Home Depot para Cuba"
               data-src="assets/market-home-depot/home_depot_boxes.png">
        </picture>
      </div>
    </div>

  </div>
</section>

